import { AnalyticsErrorDataFrame } from './analytics-error-data-frame.controller'

function analyticsErrorDataFrame () {
  return {
    restrict: 'E',
    scope: {
      type: '<',
      flags: '=',
      refreshCallback: '&'
    },
    templateUrl: '/analytics/directives/analytics-error-data-frame/analytics-error-data-frame-directive.html?$$REVISION$$',
    controller: AnalyticsErrorDataFrame
  }
}

export { analyticsErrorDataFrame }
